import React, { useState, useCallback } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';

import { SelectParcels } from './select-parcels';
import { SelectSurveyFields } from './select-survey-fields';
import { InviteCollaborators } from './invite-collaborators';
import { SetName } from './set-name';

const steps = [
  {
    label: 'Select Parcels',
    Component: SelectParcels,
  },
  {
    label: 'Select Survey Fields',
    Component: SelectSurveyFields,
  },
  {
    label: 'Invite Collaborators',
    Component: InviteCollaborators,
  },
  {
    label: 'Name Your Survey',
    Component: SetName,
  },
];

const mapState = createSelector(
  ({ editSurvey }) => editSurvey,
  (editSurvey) => ({ survey: editSurvey })
);

export const SurveyBuilder = ({ open, handleClose = () => {} }) => {
  const [activeStep, setActiveStep] = useState(0);
  const { survey = {} } = useSelector(mapState);

  const { Component } = steps[activeStep];
  const finish = useCallback(() => {
    setActiveStep(0);
    handleClose();
  }, [setActiveStep, handleClose]);

  return (
    <Dialog open={open} aria-labelledby="dialog-title">
      <DialogTitle id="dialog-title">
        Edit Survey:&nbsp;
        {survey == null ? 'Unnamed Survey' : survey.name}
      </DialogTitle>

      <DialogContent>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(({ label }) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {survey ? <Component survey={survey} finish={finish} /> : null}
      </DialogContent>

      <DialogActions>
        <Button onClick={finish}>
          Close
        </Button>
        {activeStep === 0 ? null : (
          <Button onClick={() => setActiveStep(activeStep - 1)} color="primary">
            Back
          </Button>
        )}

        {activeStep === steps.length - 1 ? null : (
          <Button onClick={() => setActiveStep(activeStep + 1)} color="primary">
            Next
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
